export default __webpack_public_path__ + "_/videos/lootbox/video-csgo-9023e44ff8509e32385f77991677e13263ff8e81b6cc747155733fc92fdc9eae.ogv";